import React from 'react';

import { ListOption, ListOptionGroup } from '../../../../design-system';

const ScenarioMoreOptionsPopup = ({ isEditable = true, openDeleteModal, onClose }) => {
    const handleAction = (action) => {
        if (!isEditable) return;

        action();
        onClose();
    };

    return (
        <div className="absolute right-0 top-full z-10">
            <ListOptionGroup
                fixedWidth={300}
                listOptions={
                    <>
                        <ListOption
                            leadingIconName="deleteBin4LineIcon"
                            text="Delete Scenario"
                            textColor="#E95B69"
                            iconColor="#E95B69"
                            isDisabled={!isEditable}
                            onClick={() => handleAction(openDeleteModal)}
                        />
                    </>
                }
                handleClose={(e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    onClose();
                }}
            />
        </div>
    );
};

export default ScenarioMoreOptionsPopup;
